export const isWebViewApp = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return (
    /Mobile|Android|iPhone|iPad|iPod/.test(userAgent) &&
    /wv|WebView|FBAN|FBAV/.test(userAgent)
  );
};

export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export const throttle = (func, delay) => {
  let lastCallTime = 0;
  return (...args) => {
    const now = new Date().getTime();
    if (now - lastCallTime < delay) return;
    lastCallTime = now;
    func(...args);
  };
};

export const isValidPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/\D/g, '');
  return cleaned.length === 10;
};

export const getBrowser = () => {
  const userAgent = navigator.userAgent;
  let browser = 'unknown';

  // Chrome
  if (/Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
    if (/Edg/.test(userAgent)) {
      browser = 'edge';
    } else if (/OPR/.test(userAgent)) {
      browser = 'opera';
    } else {
      browser = 'chrome';
    }
  }
  // Firefox
  else if (/Firefox|FxiOS/.test(userAgent)) {
    browser = 'firefox';
  }
  // Safari
  else if (
    /Safari/.test(userAgent) &&
    /Apple Computer/.test(navigator.vendor)
  ) {
    browser = 'safari';
  }
  // Samsung Browser
  else if (/SamsungBrowser/.test(userAgent)) {
    browser = 'samsung';
  }
  // UC Browser
  else if (/UCBrowser/.test(userAgent)) {
    browser = 'uc';
  }

  return {
    browser,
    isChrome: browser === 'chrome',
    isSafari: browser === 'safari',
    isFirefox: browser === 'firefox',
    isSamsung: browser === 'samsung',
    isUc: browser === 'uc',
  };
};

export const isInAppBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  const inAppIndicators =
    /FBAN|FBAV|Instagram|FB_IAB|WhatsApp|Snapchat|Line|LinkedInApp|Twitter/i;
  const isInApp = inAppIndicators.test(ua);

  return isInApp;
};

export const detectMobileBrowser = () => {
  const ua = navigator.userAgent;

  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);

  const isChrome = /CriOS|Chrome/i.test(ua) && !/Edg/i.test(ua);
  const isSafari =
    /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|OPiOS|EdgiOS/i.test(ua);

  if (isIOS && isSafari) return 'Safari (iOS)';
  if (isIOS && isChrome) return 'Chrome (iOS)';
  if (isAndroid && isChrome) return 'Chrome (Android)';

  return 'Other';
};

const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
const months_full = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function formatDateToCustomString(date) {
  const day = days[date.getDay()];
  const month = months[date.getMonth()];
  const dateNum = date.getDate();
  const year = date.getFullYear();

  const hours = date.getHours() % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

  return `${day}, ${month} ${dateNum}, ${year} ${hours}:${minutes}:${seconds} ${ampm}`;
}
